// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: 'AIzaSyACuVM4ljtaRoDjlhjAbo4-RT-rZmhrkRk',
    authDomain: 'ostobuddy-prod.firebaseapp.com',
    databaseURL: 'https://ostobuddy-prod.firebaseio.com',
    projectId: 'ostobuddy-prod',
    storageBucket: 'ostobuddy-prod.appspot.com',
    messagingSenderId: '456048841692',
    appId: '1:456048841692:web:8cc2336dc8085a4724f519'
  },
  changeUserEmail: 'http://localhost:5000/ostobuddy-prod/us-central1/updateEmailAddress',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
